import React, { useEffect, useState } from "react";
import styles from "./../../../assets/scss/custom.module.scss";
import { SuccessfullModal } from "../../../components/modals/SuccessfullModal";
import {
  dashboard,
  InvoiceDetails,
  processing,
  responseStatus,
  tooltips
} from "../../../locales/en";
import RepayDatePickerV1 from "../../../components/datepicker/RepayDatePickerV1";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { getQuoteStatusThunk } from "../../../redux/dashboardSlice";
import { showToast } from "../../../utils/utils";

const PaymentFilterShow = (props) => {
  const {
    handleGroupStatusChange,
    grpStatus,
    handleGroupRepayDate,
    grpRepaydate,
    handleArchiveInvoices,
    archivedLoading
  } = props;
  const dispatch = useDispatch();

  const [quoteStatus, setQuoteStatus] = useState([]);

  const [addSuccessfullModal, setAddSuccessfullModal] = useState(false);
  const toggleAddSuccessfullModal = () => {
    setAddSuccessfullModal(!addSuccessfullModal);
  };

  useEffect(() => {
    const loadQuoteStatus = async () => {
      try {
        const response = await dispatch(getQuoteStatusThunk()).unwrap();
        setQuoteStatus(response.data.data || []);
      } catch (error) {
        showToast(error.response?.data?.message, responseStatus?.error);
      }
    };
    loadQuoteStatus();
  }, []);

  const excludedStatuses = [
    { status: "Funded", id: 4 },
    { status: "Bank file generating", id: 13 },
    { status: "Approved", id: 2 },
    { status: "Outstanding", id: 3 },
    { status: "No AML", id: 10 },
    { status: "Processing", id: 7 }
  ];

  return (
    <>
      <div className="main-filter-bar flex-wrap mb-3">
        <div className="d-flex flex-wrap align-self-center mb-1 mt-1">
          <ul
            className={`${styles.topActioniconBtn} d-flex flex-wrap justify-content-md-end align-items-center ms-0`}
          >
            <li>
              <select
                name="status_sort"
                className={styles.selectShowStatus}
                value={grpStatus}
                onChange={handleGroupStatusChange}
              >
                <option value="">
                  {InvoiceDetails?.fundtapInformation?.status}
                </option>
                {quoteStatus
                  .filter((item) => {
                    const isExcluded = excludedStatuses.some(
                      (ex) => ex.status === item.status && ex.id === item.id
                    );
                    return !isExcluded;
                  })
                  .map((status) => (
                    <option key={status.id} value={status.id}>
                      {status.status}
                    </option>
                  ))}
              </select>
            </li>
            <li>
              <RepayDatePickerV1
                className={styles.filterDate}
                onChange={handleGroupRepayDate}
                value={grpRepaydate}
              />
            </li>
            <li>
              <button
                type="button"
                className={`${styles.applyBtn} btn btn-primary`}
                onClick={handleArchiveInvoices}
                disabled={archivedLoading}
              >
                {archivedLoading ? processing : `${tooltips?.archive}`}
              </button>
            </li>
          </ul>
        </div>
      </div>

      <SuccessfullModal
        isOpen={addSuccessfullModal}
        toggle={toggleAddSuccessfullModal}
        title={dashboard?.successModal?.title}
        message={dashboard?.successModal?.message}
      />
    </>
  );
};
PaymentFilterShow.propTypes = {
  handleGroupStatusChange: PropTypes.func,
  grpStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleGroupRepayDate: PropTypes.func,
  grpRepaydate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  handleArchiveInvoices: PropTypes.func,
  archivedLoading: PropTypes.bool
};

export default PaymentFilterShow;
